module.exports = __webpack_public_path__ + "assets/img/report_bgc.4fc18622.png";